import React, { useMemo, useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";

import ObtieneDatosCookies from "../tools/obtieneDatosCookiesUsuario.js";
import asignaPass from "../tools/asignaPass.js";
import devuelveSedeConsultada from "../tools/devuelveSede.js";
import devuelveDependenciaConstultada from "../tools/devuelveDependencia.js";

// ============================================================
// COMPONENTE
// ============================================================

function ModuloCreaUsuario(props) {
  const destinos =
    devuelveDependenciaConstultada() || [];

  const sedes =
    devuelveSedeConsultada() || [];

  const Usuario =
    ObtieneDatosCookies();

  const URI =
    "https://wwwa.isepsantafe.net.ar/expedientes/usuarios/crea/";

  // ==========================================================
  // ESTADOS
  // ==========================================================

  const [
    creando,
    setCreando,
  ] = useState(false);

  // ==========================================================
  // FORM
  // ==========================================================

  const {
    register,
    handleSubmit,
    watch,
    reset,

    formState: {
      errors,
      isDirty,
    },
  } = useForm({
    defaultValues: {
      apellido: "",
      nombre: "",
      identificacion: "",
      sedeID:
        sedes?.[0]?.id || "",
      destino:
        destinos?.[0]?.id || "",
      nivel:
        String(Usuario?.nivel) === "1"
          ? "1"
          : "3",
      estado: "1",
    },
  });

  // ==========================================================
  // DATOS VISUALES
  // ==========================================================

  const sedeSeleccionada =
    watch("sedeID");

  const destinoSeleccionado =
    watch("destino");

  const nivelSeleccionado =
    watch("nivel");

  const estadoSeleccionado =
    watch("estado");

  const sedeActual =
    useMemo(() => {
      return sedes.find(
        (item) =>
          String(item.id) ===
          String(
            sedeSeleccionada
          )
      );
    }, [
      sedes,
      sedeSeleccionada,
    ]);

  const destinoActual =
    useMemo(() => {
      return destinos.find(
        (item) =>
          String(item.id) ===
          String(
            destinoSeleccionado
          )
      );
    }, [
      destinos,
      destinoSeleccionado,
    ]);

  // ==========================================================
  // NOMBRE DEL NIVEL
  // ==========================================================

  const nombreNivel = (
    nivel
  ) => {
    switch (
      String(nivel)
    ) {
      case "1":
        return "Super User";

      case "2":
        return "Administrador";

      case "3":
        return "Operador";

      case "4":
        return "Observador";

      default:
        return `Nivel ${nivel}`;
    }
  };

  // ==========================================================
  // CREAR USUARIO
  // ==========================================================

  const creaUsuario =
    async (data) => {
      const apellido =
        String(
          data.apellido ||
            ""
        )
          .trim()
          .toUpperCase();

      const nombre =
        String(
          data.nombre ||
            ""
        ).trim();

      const identificacion =
        String(
          data.identificacion ||
            ""
        ).trim();

      // ======================================================
      // CONFIRMAR
      // ======================================================

      const confirmacion =
        await Swal.fire({
          title:
            "¿Crear nuevo usuario?",

          html: `
            <div style="text-align:left">
              Se creará el siguiente usuario:
              <br/><br/>

              <b>Apellido:</b> ${apellido}<br/>
              <b>Nombre:</b> ${nombre}<br/>

              ${
                identificacion
                  ? `<b>Identificación:</b> ${identificacion}<br/>`
                  : ""
              }

              ${
                sedeActual
                  ? `<b>Sede:</b> ${sedeActual.descripcion}<br/>`
                  : ""
              }

              ${
                destinoActual
                  ? `<b>Destino:</b> ${destinoActual.descripcion}<br/>`
                  : ""
              }

              <b>Nivel:</b> ${nombreNivel(
                nivelSeleccionado
              )}<br/>

              <b>Estado:</b> ${
                String(
                  estadoSeleccionado
                ) === "1"
                  ? "Activo"
                  : "Suspendido"
              }

              <br/><br/>

              La contraseña inicial será:
              <br/>

              <strong style="font-size:20px">
                Alem+2050
              </strong>
            </div>
          `,

          icon: "question",

          showCancelButton:
            true,

          confirmButtonText:
            "Sí, crear usuario",

          cancelButtonText:
            "Cancelar",

          reverseButtons:
            true,
        });

      if (
        !confirmacion.isConfirmed
      ) {
        return;
      }

      try {
        setCreando(true);

        // ====================================================
        // GENERAR HASH/PASS
        // ====================================================

        const nuevoPass =
          await asignaPass(
            "Alem+2050"
          );

        const pass =
          nuevoPass.pass;

        // ====================================================
        // PAYLOAD
        // ====================================================

        const datosEnviar = {
          ...data,

          apellido,

          nombre,

          identificacion,

          pass,

          blanqueoContrasena:
            1,
        };

        // ====================================================
        // CREAR
        // ====================================================

        const resultado =
          await axios.post(
            URI,
            datosEnviar
          );

        // ====================================================
        // RESPUESTA
        // ====================================================

        if (
          resultado?.data
            ?.message ===
          "Registro creado correctamente!!"
        ) {
          await Swal.fire({
            icon: "success",

            title:
              "Usuario creado",

            html: `
              <div>
                El usuario fue creado correctamente.
                <br/><br/>

                Contraseña inicial:
                <br/>

                <strong style="font-size:22px">
                  Alem+2050
                </strong>

                <br/><br/>

                <span style="color:#64748b">
                  El usuario deberá cambiarla al ingresar.
                </span>
              </div>
            `,

            confirmButtonText:
              "Aceptar",
          });

          reset();

          if (
            typeof props.myID ===
            "function"
          ) {
            props.myID(
              "return"
            );
          }

          return;
        }

        // ====================================================
        // RESPUESTA NO ESPERADA
        // ====================================================

        console.error(
          "Respuesta inesperada al crear usuario:",
          resultado?.data
        );

        await Swal.fire({
          icon: "error",

          title:
            "No se pudo crear",

          text:
            resultado?.data
              ?.message ||
            "Algo falló al crear el usuario. Contacte al soporte técnico.",
        });
      } catch (error) {
        console.error(
          "Error creando usuario:",
          error
        );

        await Swal.fire({
          icon: "error",

          title:
            "Error al crear usuario",

          text:
            error?.response
              ?.data?.message ||
            error?.response
              ?.data?.error ||
            error?.message ||
            "No se pudo crear el usuario.",
        });
      } finally {
        setCreando(false);
      }
    };

  // ==========================================================
  // ESTILOS
  // ==========================================================

  const estiloLabel = {
    display: "block",

    fontSize: "12px",

    fontWeight: 700,

    color: "#64748b",

    marginBottom: "6px",

    textTransform:
      "uppercase",

    letterSpacing:
      ".03em",
  };

  const estiloInput = {
    width: "100%",

    minHeight: "44px",

    padding:
      "9px 12px",

    border:
      "1px solid #cbd5e1",

    borderRadius:
      "9px",

    background:
      "#fff",

    color:
      "#1e293b",

    fontSize:
      "14px",

    textAlign:
      "left",

    boxSizing:
      "border-box",
  };

  const estiloTarjeta = {
    background:
      "#fff",

    border:
      "1px solid #e2e8f0",

    borderRadius:
      "14px",

    overflow:
      "hidden",

    marginBottom:
      "18px",
  };

  // ==========================================================
  // RENDER
  // ==========================================================

  return (
    <div
      style={{
        width:
          "100%",

        maxWidth:
          "1050px",

        margin:
          "0 auto",

        textAlign:
          "left",
      }}
    >
      {/* ======================================================
          CABECERA
      ====================================================== */}

      <div
        style={{
          background:
            "linear-gradient(135deg,#eff6ff,#f8fafc)",

          border:
            "1px solid #dbeafe",

          borderRadius:
            "14px",

          padding:
            "18px",

          marginBottom:
            "20px",

          display:
            "flex",

          alignItems:
            "center",

          gap:
            "14px",
        }}
      >
        <div
          style={{
            width:
              "54px",

            height:
              "54px",

            borderRadius:
              "50%",

            background:
              "#1e3a5f",

            color:
              "#fff",

            display:
              "flex",

            justifyContent:
              "center",

            alignItems:
              "center",

            fontSize:
              "24px",

            flexShrink:
              0,
          }}
        >
          ＋
        </div>

        <div>
          <div
            style={{
              color:
                "#64748b",

              fontSize:
                "12px",

              textTransform:
                "uppercase",

              fontWeight:
                700,
            }}
          >
            Gestión de usuarios
          </div>

          <div
            style={{
              color:
                "#172033",

              fontSize:
                "21px",

              fontWeight:
                700,
            }}
          >
            Nuevo usuario
          </div>

          <div
            style={{
              color:
                "#64748b",

              marginTop:
                "2px",

              fontSize:
                "13px",
            }}
          >
            Complete los datos para dar de alta
            una nueva cuenta en SIGEDI.
          </div>
        </div>
      </div>

      {/* ======================================================
          FORM
      ====================================================== */}

      <form
        onSubmit={
          handleSubmit(
            creaUsuario
          )
        }
      >
        {/* ====================================================
            DATOS PERSONALES
        ==================================================== */}

        <div
          style={
            estiloTarjeta
          }
        >
          <div
            style={{
              padding:
                "13px 17px",

              background:
                "#f8fafc",

              borderBottom:
                "1px solid #e2e8f0",

              fontWeight:
                700,

              color:
                "#334155",
            }}
          >
            👤 Datos del usuario
          </div>

          <div
            style={{
              padding:
                "18px",

              display:
                "grid",

              gridTemplateColumns:
                "repeat(auto-fit,minmax(250px,1fr))",

              gap:
                "16px",
            }}
          >
            {/* APELLIDO */}

            <div>
              <label
                style={
                  estiloLabel
                }
              >
                Apellido
              </label>

              <input
                type="text"

                placeholder="Apellido"

                autoComplete="off"

                style={{
                  ...estiloInput,

                  borderColor:
                    errors.apellido
                      ? "#dc2626"
                      : "#cbd5e1",
                }}

                {...register(
                  "apellido",
                  {
                    required:
                      "El apellido es obligatorio",

                    minLength: {
                      value:
                        3,

                      message:
                        "El apellido debe tener al menos 3 caracteres",
                    },

                    maxLength: {
                      value:
                        32,

                      message:
                        "Máximo 32 caracteres",
                    },
                  }
                )}
              />

              {errors.apellido && (
                <div
                  style={{
                    color:
                      "#dc2626",

                    fontSize:
                      "12px",

                    marginTop:
                      "5px",
                  }}
                >
                  {
                    errors
                      .apellido
                      .message
                  }
                </div>
              )}
            </div>

            {/* NOMBRE */}

            <div>
              <label
                style={
                  estiloLabel
                }
              >
                Nombre
              </label>

              <input
                type="text"

                placeholder="Nombre"

                autoComplete="off"

                style={{
                  ...estiloInput,

                  borderColor:
                    errors.nombre
                      ? "#dc2626"
                      : "#cbd5e1",
                }}

                {...register(
                  "nombre",
                  {
                    required:
                      "El nombre es obligatorio",

                    minLength: {
                      value:
                        3,

                      message:
                        "El nombre debe tener al menos 3 caracteres",
                    },

                    maxLength: {
                      value:
                        32,

                      message:
                        "Máximo 32 caracteres",
                    },
                  }
                )}
              />

              {errors.nombre && (
                <div
                  style={{
                    color:
                      "#dc2626",

                    fontSize:
                      "12px",

                    marginTop:
                      "5px",
                  }}
                >
                  {
                    errors
                      .nombre
                      .message
                  }
                </div>
              )}
            </div>

            {/* IDENTIFICACIÓN */}

            {String(
              Usuario.nivel
            ) === "1" && (
              <div>
                <label
                  style={
                    estiloLabel
                  }
                >
                  Nº de identificación
                </label>

                <input
                  type="text"

                  placeholder="DNI / Identificación"

                  autoComplete="off"

                  style={{
                    ...estiloInput,

                    borderColor:
                      errors.identificacion
                        ? "#dc2626"
                        : "#cbd5e1",
                  }}

                  {...register(
                    "identificacion",
                    {
                      required:
                        "La identificación es obligatoria",

                      minLength: {
                        value:
                          3,

                        message:
                          "Mínimo 3 caracteres",
                      },

                      maxLength: {
                        value:
                          16,

                        message:
                          "Máximo 16 caracteres",
                      },

                      pattern: {
                        value:
                          /^[0-9]+$/,

                        message:
                          "Ingrese solamente números",
                      },
                    }
                  )}
                />

                {errors.identificacion && (
                  <div
                    style={{
                      color:
                        "#dc2626",

                      fontSize:
                        "12px",

                      marginTop:
                        "5px",
                    }}
                  >
                    {
                      errors
                        .identificacion
                        .message
                    }
                  </div>
                )}
              </div>
            )}
          </div>
        </div>

        {/* ====================================================
            UBICACIÓN
        ==================================================== */}

        {String(
          Usuario.nivel
        ) === "1" && (
          <div
            style={
              estiloTarjeta
            }
          >
            <div
              style={{
                padding:
                  "13px 17px",

                background:
                  "#f8fafc",

                borderBottom:
                  "1px solid #e2e8f0",

                fontWeight:
                  700,

                color:
                  "#334155",
              }}
            >
              🏢 Ubicación institucional
            </div>

            <div
              style={{
                padding:
                  "18px",

                display:
                  "grid",

                gridTemplateColumns:
                  "repeat(auto-fit,minmax(280px,1fr))",

                gap:
                  "16px",
              }}
            >
              {/* SEDE */}

              <div>
                <label
                  style={
                    estiloLabel
                  }
                >
                  Sede de destino
                </label>

                <select
                  style={
                    estiloInput
                  }

                  {...register(
                    "sedeID",
                    {
                      required:
                        "Debe seleccionar una sede",
                    }
                  )}
                >
                  {sedes.map(
                    (
                      sede
                    ) => (
                      <option
                        key={
                          sede.id
                        }

                        value={
                          sede.id
                        }
                      >
                        {
                          sede.descripcion
                        }
                      </option>
                    )
                  )}
                </select>

                {errors.sedeID && (
                  <div
                    style={{
                      color:
                        "#dc2626",

                      fontSize:
                        "12px",

                      marginTop:
                        "5px",
                    }}
                  >
                    {
                      errors
                        .sedeID
                        .message
                    }
                  </div>
                )}

                {sedeActual && (
                  <div
                    style={{
                      color:
                        "#64748b",

                      fontSize:
                        "12px",

                      marginTop:
                        "5px",
                    }}
                  >
                    Seleccionada:{" "}

                    <strong>
                      {
                        sedeActual.descripcion
                      }
                    </strong>
                  </div>
                )}
              </div>

              {/* DESTINO */}

              <div>
                <label
                  style={
                    estiloLabel
                  }
                >
                  Unidad de destino
                </label>

                <select
                  style={
                    estiloInput
                  }

                  {...register(
                    "destino",
                    {
                      required:
                        "Debe seleccionar un destino",
                    }
                  )}
                >
                  {destinos.map(
                    (
                      destino
                    ) => (
                      <option
                        key={
                          destino.id
                        }

                        value={
                          destino.id
                        }
                      >
                        {
                          destino.descripcion
                        }
                      </option>
                    )
                  )}
                </select>

                {errors.destino && (
                  <div
                    style={{
                      color:
                        "#dc2626",

                      fontSize:
                        "12px",

                      marginTop:
                        "5px",
                    }}
                  >
                    {
                      errors
                        .destino
                        .message
                    }
                  </div>
                )}

                {destinoActual && (
                  <div
                    style={{
                      color:
                        "#64748b",

                      fontSize:
                        "12px",

                      marginTop:
                        "5px",
                    }}
                  >
                    Seleccionado:{" "}

                    <strong>
                      {
                        destinoActual.descripcion
                      }
                    </strong>
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        {/* ====================================================
            ACCESO
        ==================================================== */}

        <div
          style={
            estiloTarjeta
          }
        >
          <div
            style={{
              padding:
                "13px 17px",

              background:
                "#f8fafc",

              borderBottom:
                "1px solid #e2e8f0",

              fontWeight:
                700,

              color:
                "#334155",
            }}
          >
            🔐 Acceso al sistema
          </div>

          <div
            style={{
              padding:
                "18px",

              display:
                "grid",

              gridTemplateColumns:
                "repeat(auto-fit,minmax(250px,1fr))",

              gap:
                "16px",
            }}
          >
            {/* NIVEL */}

            <div>
              <label
                style={
                  estiloLabel
                }
              >
                Nivel de acceso
              </label>

              <select
                style={
                  estiloInput
                }

                {...register(
                  "nivel",
                  {
                    required:
                      true,
                  }
                )}
              >
                {String(
                  Usuario.nivel
                ) === "1" && (
                  <>
                    <option value="1">
                      Super User
                    </option>

                    <option value="2">
                      Administrador
                    </option>
                  </>
                )}

                <option value="3">
                  Operador
                </option>

                <option value="4">
                  Observador
                </option>
              </select>

              <div
                style={{
                  color:
                    "#64748b",

                  fontSize:
                    "12px",

                  marginTop:
                    "6px",
                }}
              >
                Perfil:{" "}

                <strong>
                  {nombreNivel(
                    nivelSeleccionado
                  )}
                </strong>
              </div>
            </div>

            {/* ESTADO */}

            <div>
              <label
                style={
                  estiloLabel
                }
              >
                Estado inicial
              </label>

              <select
                style={
                  estiloInput
                }

                {...register(
                  "estado",
                  {
                    required:
                      true,
                  }
                )}
              >
                <option value="1">
                  Activo
                </option>

                <option value="2">
                  Suspendido
                </option>
              </select>

              <div
                style={{
                  marginTop:
                    "6px",

                  fontSize:
                    "12px",

                  color:
                    String(
                      estadoSeleccionado
                    ) === "1"
                      ? "#047857"
                      : "#b45309",

                  fontWeight:
                    600,
                }}
              >
                ●{" "}

                {String(
                  estadoSeleccionado
                ) === "1"
                  ? "Activo"
                  : "Suspendido"}
              </div>
            </div>
          </div>
        </div>

        {/* ====================================================
            CONTRASEÑA INICIAL
        ==================================================== */}

        <div
          style={{
            background:
              "#fffbeb",

            border:
              "1px solid #fde68a",

            borderRadius:
              "14px",

            padding:
              "16px",

            marginBottom:
              "18px",

            display:
              "flex",

            alignItems:
              "flex-start",

            gap:
              "12px",
          }}
        >
          <div
            style={{
              fontSize:
                "24px",

              lineHeight:
                1,
            }}
          >
            🔑
          </div>

          <div>
            <div
              style={{
                fontWeight:
                  700,

                color:
                  "#92400e",
              }}
            >
              Contraseña inicial
            </div>

            <div
              style={{
                color:
                  "#78350f",

                fontSize:
                  "13px",

                marginTop:
                  "4px",
              }}
            >
              El usuario será creado con la contraseña{" "}

              <strong>
                Alem+2050
              </strong>{" "}

              y quedará marcado para realizar el cambio de
              contraseña.
            </div>
          </div>
        </div>

        {/* ====================================================
            FOOTER
        ==================================================== */}

        <div
          style={{
            position:
              "sticky",

            bottom:
              0,

            zIndex:
              5,

            background:
              "#f8fafc",

            border:
              "1px solid #e2e8f0",

            borderRadius:
              "12px",

            padding:
              "14px",

            display:
              "flex",

            justifyContent:
              "space-between",

            alignItems:
              "center",

            gap:
              "12px",

            flexWrap:
              "wrap",

            boxShadow:
              "0 -4px 15px rgba(15,23,42,.05)",
          }}
        >
          <div
            style={{
              color:
                "#64748b",

              fontSize:
                "13px",
            }}
          >
            {isDirty
              ? "● Datos cargados pendientes de creación"
              : "Complete los datos del nuevo usuario"}
          </div>

          <button
            type="submit"

            className="btn btn-success"

            disabled={
              creando
            }

            style={{
              minWidth:
                "180px",
            }}
          >
            {creando
              ? "Creando usuario..."
              : "＋ Crear usuario"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default ModuloCreaUsuario;